export default {"src":"/_next/static/media/mobile-inverted.72eb39a2.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};